import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.57499 7.50001C7.77091 6.94306 8.15759 6.47344 8.66659 6.17427C9.17559 5.8751 9.77403 5.76577 10.3559 5.86561C10.9378 5.96546 11.4656 6.26797 11.8458 6.71963C12.2261 7.17129 12.4342 7.74296 12.4333 8.33334C12.4333 10 9.93332 10.8333 9.93332 10.8333M10 14.1667H10.0083M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z"
    />
  </svg>
);

export { SvgComponent as HelpCircleIcon };

